import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StudyMapping {
  [key: string]: {
    study_id: number;
    organization_name: string;
  };
}

// Initialize the store with empty values for StudyMapping
const initialStudyMapping: StudyMapping = {};

// Create the study slice
export const studySlice = createSlice({
  name: 'studyMapping',
  initialState: { studyMapping: initialStudyMapping },
  reducers: {
    // Update multiple studies at once
    updateStudy: (state, action: PayloadAction<StudyMapping>) => {
        state.studyMapping = { ...state.studyMapping, ...action.payload };
    },
    removeStudy: (state, action: PayloadAction<string>) => {
      delete state.studyMapping[action.payload];
    },
    clearAllStudies: (state) => {
      state.studyMapping = {};
    },
  },
});

export const { updateStudy, removeStudy, clearAllStudies } = studySlice.actions;

export default studySlice.reducer;
